import { badgeClass } from "@/lib/constants";
import { cn } from "@/lib/utils";

export function StatusBadge({ value, className }) {
  return (
    <span
      data-testid={`badge-${String(value).toLowerCase().replace(/\s+/g, "-")}`}
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold whitespace-nowrap",
        badgeClass(value),
        className
      )}
    >
      {value}
    </span>
  );
}
